import React from "react";
import { Link } from "react-router-dom";
import Logo from "../Logo/Logo";
import "./Header.scss";

export default function Header() {
  return (
    <header className="header">
      <Link to="/">
        <Logo />
      </Link>
      <div className="header__container">
        <Link className="header__link contact--link" to="/contact">
          Contact
        </Link>
        <Link className="header__link coding--link" to="/coding">
          Coding
        </Link>
        <Link className="header__link creative--link" to="/creative">
          Creative
        </Link>
      </div>
    </header>
  );
}
